<script lang="ts" setup>
	defineProps<{
		loading?: boolean
	}>()
</script>

<template>
	<div class="mt-5 flex w-full flex-wrap items-stretch gap-y-5 sm:gap-x-12 md:flex-nowrap md:gap-y-12">
		<shared-card
			:loading="loading"
			:loader-height="400"
			:loader-width="250"
			wrapper-class="md:max-w-[256px] w-full "
			:ui="{
				container: 'h-full flex-none block  bg-white md:px-0 py-0'
			}"
		>
			<slot name="left-side" />
		</shared-card>

		<shared-card
			:loading="loading"
			:loader-height="400"
			wrapper-class="w-full md:max-w-[670px] sm:ml-auto md:flex-1 relative overflow-x-auto"
			default-class="lg:p-[40px_20px]"
			:ui="{
				container: 'shadow-none md:px-0 py-0'
			}"
		>
			<slot name="main" />
		</shared-card>
	</div>
</template>
